// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"5a223add","288":"da9ca5a1","416":"dfd31a55","538":"a006ec54","566":"46c4aa75","614":"e22dcde8"}[chunkId] + ".chunk.js";
};